import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const SavedForLater = ({ savedItems, onMoveToCart, onRemoveFromSaved }) => {
  if (savedItems.length === 0) {
    return null;
  }

  return (
    <div className="bg-surface border border-border rounded-card p-6 mt-6">
      <div className="flex items-center justify-between mb-6">
        <h3 className="font-heading font-heading-semibold text-xl text-text-primary">
          Saved for Later ({savedItems.length})
        </h3>
        <Icon name="Heart" size={20} className="text-primary" />
      </div>

      <div className="space-y-4">
        {savedItems.map((item) => (
          <div key={item.id} className="flex items-center space-x-4 p-4 bg-background rounded-input">
            {/* Product Image */}
            <div className="flex-shrink-0">
              <div className="w-16 h-16 overflow-hidden rounded-input">
                <Image
                  src={item.image}
                  alt={item.name}
                  className="w-full h-full object-cover"
                />
              </div>
            </div>

            {/* Product Details */}
            <div className="flex-1 min-w-0">
              <h4 className="font-body-semibold text-sm text-text-primary mb-1 truncate">
                {item.name}
              </h4>
              <p className="text-xs text-text-secondary mb-2">{item.category}</p>
              
              {/* Price */}
              <div className="flex items-center space-x-2">
                <span className="font-data font-data-medium text-primary">
                  ${item.price.toFixed(2)}
                </span>
                {item.originalPrice && item.originalPrice > item.price && (
                  <span className="text-xs text-text-secondary line-through">
                    ${item.originalPrice.toFixed(2)}
                  </span>
                )}
              </div>

              {/* Stock Status */}
              {item.stock === 0 ? (
                <div className="flex items-center space-x-1 mt-2">
                  <Icon name="AlertCircle" size={14} className="text-error" />
                  <span className="text-xs text-error">Out of Stock</span>
                </div>
              ) : item.stock <= 5 ? (
                <div className="flex items-center space-x-1 mt-2">
                  <Icon name="AlertTriangle" size={14} className="text-warning" />
                  <span className="text-xs text-warning">Only {item.stock} left</span>
                </div>
              ) : (
                <div className="flex items-center space-x-1 mt-2">
                  <Icon name="CheckCircle" size={14} className="text-success" />
                  <span className="text-xs text-success">In Stock</span>
                </div>
              )}
            </div>

            {/* Action Buttons */}
            <div className="flex flex-col space-y-2">
              <Button
                variant="primary"
                onClick={() => onMoveToCart(item)}
                disabled={item.stock === 0}
                className="text-xs px-3 py-1"
                iconName="ShoppingCart"
                iconSize={14}
              >
                Move to Cart
              </Button>
              <Button
                variant="ghost"
                onClick={() => onRemoveFromSaved(item.id)}
                className="text-xs px-3 py-1 text-error hover:text-error"
                iconName="Trash2"
                iconSize={14}
              >
                Remove
              </Button>
            </div>
          </div>
        ))}
      </div>

      {/* Clear All */}
      <div className="mt-6 pt-4 border-t border-border">
        <Button
          variant="outline"
          onClick={() => savedItems.forEach(item => onRemoveFromSaved(item.id))}
          className="w-full text-error hover:text-error"
          iconName="Trash2"
          iconSize={16}
        >
          Clear All Saved Items
        </Button>
      </div>
    </div>
  );
};

export default SavedForLater;